export const StartLoginComponent = {
    template: `
        <div class="landing-start-login-container">
            <div c-type="title-md-primary" class="content-padding">
                <span class="sign-up-text"
                    ng-if="!$ctrl.AuthenticationService.isAuthenticated()"
                >Sign Up with Us!</span>
                <a ui-sref="start" class="close-button"></a>
            </div>
            <already-logged-in
                ng-if="$ctrl.AuthenticationService.isAuthenticated()"
            ></already-logged-in>
            <ca-account-dialog-tabs
                ng-if="!$ctrl.AuthenticationService.isAuthenticated()"
                on-login-success="$ctrl.loginSuccessCallback()"
                on-login-error="$ctrl.loginErrorCallback(errorMessage)"
                on-forgot-password="$ctrl.forgotPasswordCallback()"
                on-send-instructions="$ctrl.sendInstructionsCallback()"
                on-forgot-password-success="$ctrl.forgotPasswordSuccessCallback()"
                on-create-account-success="$ctrl.createAccountSuccessCallback()"
                on-create-account-error="$ctrl.createAccountErrorCallback(errorMessage)"
                on-terms-of-service="$ctrl.termsOfServiceCallback()"
                on-privacy-policy="$ctrl.privacyPolicyCallback()"
                on-cancel="$ctrl.navigateToStart()"
                restaurant-name="$ctrl.restaurantInfo.general.name"
            ></ca-account-dialog-tabs>
        </div>
    `,
    controller: class {
        constructor(AuthenticationService, accountService, googleAnalyticsTrackingService, restaurantInfoFactory, $state) {
            'ngInject';

            Object.assign(this, {
                AuthenticationService, accountService, googleAnalyticsTrackingService, restaurantInfoFactory, $state
            });

            this.restaurantInfo = {};
        }

        $onInit() {
            let info = ['general'];
            this.restaurantInfoFactory.getInfo(info).then(info => this._setRestaurantInfo(info));

            // A logged in user might have navigated directly to #!/login.
            if (this.AuthenticationService.isAuthenticated()) {
                this.navigateToStart();
            }
        }

        navigateToStart() {
            // Force refresh of account data after login.
            this.accountService.getBasicInfo(true);
            this.$state.go('start');
        }

        loginSuccessCallback() {
            this.googleAnalyticsTrackingService.trackLoginSuccess();
            this.navigateToStart();
        }

        loginErrorCallback(errorMessage) {
            this.googleAnalyticsTrackingService.trackLoginError(errorMessage);
        }

        forgotPasswordCallback() {
            this.googleAnalyticsTrackingService.trackForgotPassword();
        }

        sendInstructionsCallback() {
            this.googleAnalyticsTrackingService.trackSendInstructions();
        }

        forgotPasswordSuccessCallback() {
            this.navigateToStart();
        }

        createAccountSuccessCallback() {
            this.googleAnalyticsTrackingService.trackCreateAccountSuccess();
            this.navigateToStart();
        }

        createAccountErrorCallback(errorMessage) {
            this.googleAnalyticsTrackingService.trackCreateAccountError(errorMessage);
        }

        termsOfServiceCallback() {
            this.googleAnalyticsTrackingService.trackTermsOfService();
        }

        privacyPolicyCallback() {
            this.googleAnalyticsTrackingService.trackPrivacyPolicy();
        }

        _setRestaurantInfo(info) {
            this.restaurantInfo = info;
        }
    }
};
